import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateMasterActiveCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveCourse/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllMasterActiveCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveCourse/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteAMasterActiveCourse extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("MasterActiveCourse/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateMasterActiveCourse,
  GetAllMasterActiveCourse,
  DeleteAMasterActiveCourse,
};
